import "core-js/stable"
import "regenerator-runtime/runtime"
import React from 'react'
import PropTypes from "prop-types"
import styles from "./TextField.scss"

const propTypes = {
  label: PropTypes.any,
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  setState: PropTypes.func,
  required: PropTypes.bool,
  onlyNumbers: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number
}

const defaultProps = {
  type: "text",
  className: "",
  value: "",
  placeholder: "",
  onClick: null,
  onChange: null,
  onKeyPress: null,
  setState: null,
  required: false,
  onlyNumbers: false,
  min: null,
  max: null
}

const TextField = (props) => {
  const value = props.type === "number" ? Number(props.value) : (
    props.type === "password" ? undefined : props.value
  )

  const onInput = (e) => {
    if(props.onlyNumbers) {
      props.setState ? props.setState(e.target.value.replace(/[^0-9]/g, '')) : null
    } else {
      props.setState ? props.setState(e.target.value) : null
    }
  }

  return (
    <div className={props.className}>
      <label>{props.label}</label>
      <input
        className={styles.textfield}
        type={props.type}
        id={props.id}
        name={props.name}
        value={value}
        placeholder={props.placeholder}
        onClick={props.onClick}
        onKeyPress={props.onKeyPress}
        onChange={props.onChange}
        onInput={onInput}
        required={props.required}
        min={props.min}
        max={props.max}
      />
    </div>
  )
}

TextField.propTypes = propTypes
TextField.defaultProps = defaultProps

export default TextField
